<script setup lang="ts">
import ResourceCard from '@/components/resources/ResourceCard.vue';
import useAuthStore from '@/store/AuthStore';
import type { IResources } from '@/models/Resources';

const authStore = useAuthStore();

const props = defineProps<{
  entries: IResources;
}>();
</script>

<template>
  <v-row v-if="authStore.language === 'de'">
    <v-col
      v-for="entry in props.entries.de"
      v-bind:key="entry.description"
      cols="12"
      md="6"
      lg="4"
      xl="3"
    >
      <resource-card
        :title="entry.title"
        :description="entry.description"
        :type="entry.type"
        :href="entry.href"
      />
    </v-col>
  </v-row>
  <v-row v-if="authStore.language === 'en'">
    <v-col
      v-for="entry in props.entries.en"
      v-bind:key="entry.description"
      cols="12"
      md="6"
      lg="4"
      xl="3"
    >
      <resource-card
        :title="entry.title"
        :description="entry.description"
        :type="entry.type"
        :href="entry.href"
      />
    </v-col>
  </v-row>
</template>
